module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfhDAQMFix8BDiBAAAAc0lEQVRIx+2UsQ2AMAwEL6GihRIJsQfzkDGYIBuwALMwBoIyVNQxKyAHpBQ511+c9XooGKCnUaYvdvBERHkRbzjoEgzOipuRWq0w//vhwjsMAxOtMh1YYFP3UBA2m4FCIQccQV2jgEueNMuKqOPC+sGsFx7J/W8ATQ4ulQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxNy0xMi0wNFQxMjoyMjo0NCswMTowMLMxYPIAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTctMTItMDRUMTI6MjI6NDQrMDE6MDDCbNhOAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/menu.png
// module id = 111
// module chunks = 0